/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseStudentEngagementRosterInfoData } from './genericApiResponseStudentEngagementRosterInfoData';
import type { GenericApiResponseStudentEngagementRosterInfoMessage } from './genericApiResponseStudentEngagementRosterInfoMessage';
import type { GenericApiResponseStudentEngagementRosterInfoPagination } from './genericApiResponseStudentEngagementRosterInfoPagination';
import type { GenericApiResponseStudentEngagementRosterInfoError } from './genericApiResponseStudentEngagementRosterInfoError';

export interface GenericApiResponseStudentEngagementRosterInfo {
  data?: GenericApiResponseStudentEngagementRosterInfoData;
  message?: GenericApiResponseStudentEngagementRosterInfoMessage;
  pagination?: GenericApiResponseStudentEngagementRosterInfoPagination;
  error?: GenericApiResponseStudentEngagementRosterInfoError;
  statusCode?: number;
}
